import {useMemo} from 'react';
import createResultMotion from './createResultMotion';
import generateSadFaceArray from './generateSadFaceArray';

export interface SadFacesPortalProps {
  count?: number;
  durationSecs?: number; // in seconds
  delaySecs?: number; // in seconds
}

export default function SadFacesPortal({count = 20, durationSecs, delaySecs}: SadFacesPortalProps) {
  const sadFaceItems = useMemo(
    () =>
      generateSadFaceArray({
        count,
        durationSecs,
        delaySecs,
      }),
    [count, durationSecs, delaySecs],
  );

  return createResultMotion(sadFaceItems);
}
